import clsx from 'clsx';
import { useEffect, useState } from 'react';

import StudentNav from 'src/components/global-nav/student-nav/student-nav';
import { MS_ERROR_TEXT } from 'src/constants/errors.constants';

import './middle-school-error.scss';

export type MiddleSchoolErrorProps = {
  withImage?: boolean;
};

export const MiddleSchoolError = ({
  withImage = true,
}: MiddleSchoolErrorProps) => {
  const [hasGifLoaded, setHasGifLoaded] = useState(false);

  useEffect(() => {
    if (!withImage) {
      setHasGifLoaded(true);
    }
  }, [withImage]);

  return (
    <>
      <StudentNav adultsView />
      <div className="middle-school-error" data-testid="middle-school-error">
        {hasGifLoaded && (
          <h3
            className={clsx('middle-school-error__title', {
              'middle-school-error__title--with-image': withImage,
            })}
          >
            {MS_ERROR_TEXT}
          </h3>
        )}
        {withImage && (
          <img
            className="middle-school-error__image"
            src="https://learning.amplify.com/m/598039959c3a6a30/original/sh-ms-error-cat.gif"
            alt="MiddleSchoolError"
            onLoad={() => setHasGifLoaded(true)}
          />
        )}
      </div>
    </>
  );
};
